import React, { Component } from 'react';
import { Container, Button, Table, Icon, Input } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as AppActions from '../../actions';

import { insertUtmProfile } from '../../services/UtmProfilesService';
import './UTMProfilesList.css';

class UTMProfilesList extends Component {
  state = {
    showConfirm: false,
    searchText: ''
  };

  editUtmProfile = (item) => {
    this.props.editUtmProfile(item);
  };

  deleteUtmProfile = (item) => {
    this.props.deleteUtmProfile(item.id);
  };

  copyUtmProfile = async (item) => {
    const { user } = this.props;

    const utmProfileData = {
      name: `${item.name} - Copy`,
      canvas: item.canvas,
      carousel: item.carousel,
      collection: item.collection,
      still: item.still,
      video: item.video,
      daa_still: item.daa_still,
      daa_carousel: item.daa_carousel,
      user: user.email.trim()
    };

    await insertUtmProfile(utmProfileData);
    this.props.fetchUTMProfiles();
  };

  openDialog = (id) => {
    this.setState({ showConfirm: true, deleteRowId: id });
  };

  handleCancel = () => {
    this.setState({ showConfirm: false });
  };

  searchUtms = (event, { value }) => {
    this.setState({ searchText: value });
  };

  filteredUtms = () => {
    const { utmProfiles } = this.props;
    const { searchText } = this.state;

    if (searchText) {
      return utmProfiles.filter(
        (utm) => utm.name.toLowerCase().indexOf(searchText.toLowerCase()) !== -1
      );
    }

    return utmProfiles;
  };

  render() {
    const { newUTMProfile, utmProfiles } = this.props;

    if (utmProfiles) {
      return (
        <Container fluid>
          <Input
            className="utm-search"
            placeholder="Search"
            type="text"
            name="search"
            onChange={this.searchUtms}
          />
          <div className="new-utm-link">
            <Button onClick={newUTMProfile}>NEW +</Button>
          </div>
          <Table sortable celled>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>UTM Profile Name</Table.HeaderCell>
                <Table.HeaderCell className="utm-row-operations">
                  Operations
                </Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {this.filteredUtms().map((item) => (
                <Table.Row key={item.id}>
                  <Table.Cell>{item.name}</Table.Cell>
                  <Table.Cell className="utm-operations-buttons">
                    {this.state.showConfirm &&
                    item.id === this.state.deleteRowId ? (
                      <div className="utm-div-confirm">
                        <p className="text-confirm">Are you sure?</p>
                        <Button
                          onClick={() => this.deleteUtmProfile(item)}
                          size="mini"
                          color="grey"
                        >
                          Yes
                        </Button>
                        <Button
                          onClick={this.handleCancel}
                          size="mini"
                          color="red"
                        >
                          No
                        </Button>
                      </div>
                    ) : (
                      <div>
                        <a
                          role="button"
                          tabIndex={0}
                          className="utm-icon-link"
                          onClick={() => this.openDialog(item.id)}
                        >
                          <Icon size="large" name="trash alternate" />
                        </a>
                        <a
                          role="button"
                          tabIndex={0}
                          className="utm-icon-link"
                          onClick={() => this.copyUtmProfile(item)}
                        >
                          <Icon size="large" name="copy outline" />
                        </a>
                        <a
                          role="button"
                          tabIndex={0}
                          className="utm-icon-link"
                          onClick={() => this.editUtmProfile(item)}
                        >
                          <Icon size="large" name="edit" />
                        </a>
                      </div>
                    )}
                  </Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
        </Container>
      );
    }
    return null;
  }
}

const mapStateToProps = (state) => ({
  user: state.user
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(AppActions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UTMProfilesList);



// WEBPACK FOOTER //
// ./src/screens/UTMProfiles/UTMProfilesList.js